export * from "./HoReCaLocator";
export type { HoReCaLocatorProps } from "./types";
